import { setupRoutes } from '../../helpers/routes/setup';
import ROUTE from './route';

const {
  ROUTE_KEY,
  ROUTES,
  getRouteKeyForPath,
  getUrlForRouteKey,
  getRouteKeyOfChild,
} = setupRoutes(ROUTE);

export {
  ROUTE_KEY,
  ROUTES,
  getRouteKeyForPath,
  getUrlForRouteKey,
  getRouteKeyOfChild,
};
